import React from 'react';
import { useReframe } from 'nike-re-framejs';

import isRvoReason from '@/rvo/isRvoReason';
import UserAnnouncement from '@/menu/views/UserAnnouncement';
import RvoIcon from 'nike-ui/src/icons/svg/rvo-icon-sv.svg';
import i18n from '@i18n';
import { Button } from 'nike-ui/src/components/button/Button';
import { navigate } from '@/routing';
import { BLOCKED_BY_RVO, RVO_UNAVAILABLE } from '@/routing/routes';
import { accountForbiddenActionReason$ } from '@/account/subs';

function RvoStatus() {
    const { subscribe } = useReframe();
    const forbiddenReason = subscribe(accountForbiddenActionReason$('PLACE_BETSLIP'));
    return isRvoReason(forbiddenReason) ? (
        <UserAnnouncement
            icon={RvoIcon}
            title={forbiddenReason === 'RVO' ? i18n('rvo.blocked.title') : i18n('rvo.unavailable.title')}
            description={
                forbiddenReason === 'RVO' ? i18n('rvo.blocked.description') : i18n('rvo.unavailable.description')
            }
        >
            <Button
                className="red"
                onClick={() => navigate(forbiddenReason === 'RVO' ? BLOCKED_BY_RVO : RVO_UNAVAILABLE)}
                label={i18n('application.readMore')}
                primary
            />
        </UserAnnouncement>
    ) : null;
}

export default RvoStatus;
